import { Component } from '@angular/core';
import { Configuration } from './app.constants';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  ngOnInit() {
    console.log(Configuration.version);
    //CHUNCHO FORTE. RESOLVER!

    // window.location.href ='https://painel.polen.com.br';

    if (window.location.hash == "#/") {
      window.location.href = "/#/profile/onboarding"
    }

    if (window.location.hash == "/") {
      window.location.href = "/#/profile/onboarding"
    }

    if (window.location.hash == "") {
      window.location.href = "/#/profile/onboarding"
    }
  }
}
